import { tzTokenizeDate as N } from "../tzTokenizeDate/index.js";
import { newDateUTC as I } from "../newDateUTC/index.js";
const a = 36e5, m = 6e4, u = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function z(e, t, o) {
  if (!e)
    return 0;
  let c = u.timezoneZ.exec(e);
  if (c)
    return 0;
  let n, r;
  if (c = u.timezoneHH.exec(e), c)
    return n = parseInt(c[1], 10), l(n) ? -(n * a) : NaN;
  if (c = u.timezoneHHMM.exec(e), c) {
    n = parseInt(c[2], 10);
    const s = parseInt(c[3], 10);
    return l(n, s) ? (r = Math.abs(n) * a + s * m, c[1] === "+" ? -r : r) : NaN;
  }
  if (H(e)) {
    t = new Date(t || Date.now());
    const s = o ? t : M(t), i = f(s, e);
    return -(o ? i : D(t, i, e));
  }
  return NaN;
}
function M(e) {
  return I(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function f(e, t) {
  const o = N(e, t), c = I(o[0], o[1] - 1, o[2], o[3] % 24, o[4], o[5], 0).getTime();
  let n = e.getTime();
  const r = n % 1e3;
  return n -= r >= 0 ? r : 1e3 + r, c - n;
}
function D(e, t, o) {
  let n = e.getTime() - t;
  const r = f(new Date(n), o);
  if (t === r)
    return t;
  n -= r - t;
  const s = f(new Date(n), o);
  return r === s ? r : Math.max(r, s);
}
function l(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
const T = {};
function H(e) {
  if (T[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), T[e] = !0, !0;
  } catch (t) {
    return !1;
  }
}
export {
  z as tzParseTimezone
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/_lib/tzParseTimezone/index.js
// module id = 422
// module chunks = 41